import { render, staticRenderFns } from "./designinfo.vue?vue&type=template&id=44f4456e&scoped=true&"
import script from "./designinfo.vue?vue&type=script&lang=js&"
export * from "./designinfo.vue?vue&type=script&lang=js&"
import style0 from "./designinfo.vue?vue&type=style&index=0&id=44f4456e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4456e",
  null
  
)

export default component.exports